import { connect } from 'react-redux';
import {
  actionUpdateMyPassword,
  actionUpdateMyPasswordFailed,
} from 'store/actions';
import ChangePassword from './ChangePassword';

const mapStateToProps = (state) => ({
  me: state.Profile.me,
  profilePasswordError: state.Profile.passwordError,
  profileLoadingPassword: state.Profile.loadingPassword,
});

const mapDispatchToProps = (dispatch) => ({
  actionUpdateMyPassword: (payload) =>
    dispatch(actionUpdateMyPassword(payload)),
  actionUpdateMyPasswordFailed: (payload) =>
    dispatch(actionUpdateMyPasswordFailed(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
